import React from "react";
import { Card } from "react-bootstrap";
import classes from "./SummaryCard.module.css";

const SummaryCard = (props) => {
  return (
    <Card className={classes.Shadow}>
      <Card.Body>
        <p className={classes.Text}>{props.Title}</p>
        <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
        {/* <p className={classes.Figures}>
          <AnimatedNumbers
            animateToNumber={props.Value}
            includeComma
            fontStyle={{ fontSize: 32 }}
          ></AnimatedNumbers>
        </p> */}
        <p className={classes.Figures}>
          {props.dispSum
            ? "₦" + parseFloat(props.Value).toLocaleString()
            : "*****"}
        </p>
      </Card.Body>
    </Card>
  );
};

export default SummaryCard;
